import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossCircleFilledRed = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14.8335,
		cy: 15,
		r: 14.25,
		fill: "#F5222D"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.0017 9.99443L19.8389 8.83167L15.2291 13.4415L10.6193 8.83167L9.45654 9.99443L14.0664 14.6042L9.45654 19.214L10.6193 20.3768L15.2291 15.767L19.8389 20.3768L21.0017 19.214L16.3919 14.6042L21.0017 9.99443Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCrossCircleFilledRed);
export { ForwardRef as ReactComponent };
